module.exports = __webpack_public_path__ + "img/rule1.af31372d.png";